import React, { useState, useImperativeHandle, useEffect } from "react";
import Icon1 from "../icons/Icon";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { useAppContext } from "../config/AppContext";
import Tippy from "@tippyjs/react";
import { useSnackbar } from "notistack";

const CustomAccordion = ({
  userData,
  nopin = false,
  className = "font-semibold",
  title,
  children,
  startOpen = false,
  id = null,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const toggleAccordion = (e) => {
    e.stopPropagation();
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handlePin = async (e) => {
    e.stopPropagation();
    let preferences = userData?.preferences || {};
    let pinned = preferences.pinned || {};
    pinned[id ? id : title] = true;
    await updateDocDataFieldApi(
      userData.ref,
      "preferences.pinned",
      pinned,
      prefix
    );
    let newuserData = {
      ...userData,
      ...preferences,
      pinned: pinned,
    };

    handleClickVariant("Epinglé", "success");
  };

  const handleUnPin = async (e) => {
    e.stopPropagation();
    let preferences = userData.preferences || {};
    let pinned = preferences.pinned || {};
    pinned[id ? id : title] = false;

    await updateDocDataFieldApi(
      userData.ref,
      "preferences.pinned",
      pinned,
      prefix
    );
    let newuserData = {
      ...userData,
      ...preferences,
      pinned: pinned,
    };
    handleClickVariant("Désépinglé", "success");
  };

  useEffect(() => {
    const shouldOpen =
      startOpen ||
      (userData &&
        userData.preferences &&
        userData.preferences.pinned &&
        userData.preferences.pinned[id ? id : title]);

    if (shouldOpen) {
      setIsOpen(true);
    }
  }, [startOpen, userData, id, title]);

  return (
    <div className={`min-h-fit w-full `}>
      <div
        className={`w-full  rounded-lg ${
          isOpen ? "h-auto min-h-fit" : "h-fit"
        } ${isOpen ? "" : "overflow-hidden"} `}
      >
        {/* Accordion Header */}
        <div
          className="bg-slate-100 select-none px-3 py-1 cursor-pointer  rounded-lg hover:border-1 border-blue-300"
          onClick={toggleAccordion}
        >
          <div
            className={`flex flex-row items-center justify-between ${className}`}
          >
            <div> {title}</div>{" "}
            {nopin === false && (
              <div>
                {userData &&
                userData.preferences &&
                userData.preferences.pinned &&
                userData.preferences.pinned[id ? id : title] ? (
                  <div>
                    <Tippy
                      content={"Ne pas épingler"}
                      className="custom-tooltip"
                      delay={500}
                    >
                      <div onClick={handleUnPin}>
                        <Icon1
                          icon_name="pin"
                          size={18}
                          fill="blue"
                          hover_color="#ff0004"
                        />
                      </div>
                    </Tippy>{" "}
                  </div>
                ) : (
                  <div>
                    <Tippy
                      content={"Epingler"}
                      className="custom-tooltip"
                      delay={500}
                    >
                      <div onClick={handlePin}>
                        <Icon1
                          icon_name="pin"
                          size={18}
                          fill="grey"
                          hover_color="blue"
                        />
                      </div>
                    </Tippy>{" "}
                  </div>
                )}
              </div>
            )}
            {nopin === true &&
              (isOpen ? (
                <Icon1 icon_name="up" size={16} fill="blue" />
              ) : (
                <Icon1 icon_name="down" size={16} fill="blue" />
              ))}
          </div>
        </div>

        {/* Accordion Content */}
        <div
          className="p-1 pb-4"
          style={{
            display: isOpen ? "block" : "none",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default CustomAccordion;
